import { render, staticRenderFns } from "./AccountPatientCustomerData.vue?vue&type=template&id=39b32fa2&"
import script from "./AccountPatientCustomerData.vue?vue&type=script&lang=js&"
export * from "./AccountPatientCustomerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports